import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { JobTitleMutator } from '@/lib/entity/job_title'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type JobTitleSchema = JobTitleMutator['merged']

export const JobTitleConverter: Converter<JobTitleSchema> = {
  icon: () => i18next.t('stages.icon.job_title'),
  title: () => i18next.t('stages.table.job_title'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.job_title.${column}`)
    return match(column)
      .with('name', 'choosable', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
